<template>
	<div id="form" class="column col-lg-6 col-md-6 col-sm-12">
		<div class="panel">
			<div class="panel-header">
				<div class="panel-title"><b>Générateur de signature mail</b></div>
				<div class="panel-body">
					<form @submit.prevent="submitFields">
						<div class="form-group">
							<label class="form-label" for="input-firstname"
								>Prénom</label
							>
							<input
								class="form-input"
								type="text"
								id="input-firstname"
								v-model="firstname"
								placeholder="Prénom"
							/>
						</div>

						<div class="form-group">
							<label class="form-label" for="input-name">Nom</label>
							<input
								class="form-input"
								type="text"
								id="input-name"
								v-model="name"
								placeholder="Nom"
							/>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-usertitle"
								>Titre ou fonction</label
							>
							<textarea
								class="form-input"
								id="input-usertitle"
								v-model="usertitle"
								placeholder="Titre ou fonction"
							></textarea>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-userphone"
								>Téléphone</label
							>
							<input
								class="form-input"
								type="text"
								id="input-userphone"
								v-model="userphone"
								placeholder="Téléphone"
							/>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-usermail"
								>Adresse e-mail</label
							>
							<input
								class="form-input"
								type="text"
								id="input-usermail"
								v-model="usermail"
								placeholder="Adresse e-mail"
							/>
						</div>
						<div class="form-group" style="display: none">
							<label class="form-label" for="input-useraddress"
								>Adresse</label
							>
							<textarea
								class="form-input"
								id="input-useraddress"
								v-model="useraddress"
								placeholder="Adresse"
							></textarea>
						</div>

						<div class="form-group">
							<label class="form-label" for="input-userlinkedin"
								>LinkedIn</label
							>
							<input
								class="form-input"
								type="text"
								id="input-userlinkedin"
								v-model="userlinkedin"
								placeholder="Lien LinkedIn"
							/>
						</div>
						<div class="form-group">
							<button type="submit" class="btn btn-primary">
								Mettre à jour
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Form",
	data: function () {
		return {
			name: "",
			firstname: "",
			usertitle: "",
			usertitlehtml: "",
			userphone: "",
			usermail: "",
			userlinkedin: "",
		};
	},
	watch: {
		usertitle: function (newValue) {
			this.usertitlehtml = newValue.replace(/\r?\n/g, "<br />");
		},
	},
	methods: {
		submitFields: function () {
			this.$emit("submitFields", [
				this.name,
				this.firstname,
				this.usertitlehtml,
				this.userphone,
				this.usermail,
				this.userlinkedin,
			]);
		},
	},
};
</script>

<style></style>
